import React from "react";
import Menu from "./Menu";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
  Stack
} from "@mui/material";

import {
  Phone,
  Email,
  WhatsApp,
  SupportAgent,
  Language
} from "@mui/icons-material";

function Help() {

  const callNumber = "8459432930";
  const whatsappNumber = "918830561612";
  const email = "blueviperstechnology@gmail.com";
  const website = "https://blueviperstechnology.com";

  return (

    <Box p={2} >

      {/* HEADER */}
      <Card
        sx={{
          mb: 4,
          borderRadius: 4,
          background: "linear-gradient(135deg,teal,#42a5f5)",
          color: "#fff",
        }}
      >
        <CardContent>

          <Stack direction="row" spacing={2} alignItems="center">

            <SupportAgent sx={{ fontSize: 50 }} />

            <Box>
              <Typography fontSize={28} fontWeight={800}>
                Help & Support
              </Typography>

              <Typography fontSize={14} sx={{ opacity: 0.9 }}>
                Contact our support team anytime
              </Typography>

              <Typography fontSize={13} mt={1}>
                Support by <b>Rohan Thorat</b>
              </Typography>
            </Box>

          </Stack>

        </CardContent>
      </Card>

      {/* SUPPORT CARDS */}

      <Grid className="row" spacing={3}>

        {/* CALL */}

        <Grid className="col-sm-3 mb-2">

          <Card
            sx={{
              borderRadius: 4,
              transition: "0.3s",
              "&:hover": { transform: "translateY(-6px)" }
            }}
          >
            <CardContent>

              <Box
                sx={{
                  width: 56,
                  height: 56,
                  borderRadius: "50%",
                  bgcolor: "#1976d2",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 2
                }}
              >
                <Phone />
              </Box>

              <Typography fontWeight={700} fontSize={18}>
                Call Support
              </Typography>

              <Typography color="text.secondary">
                Speak directly with support
              </Typography>

              <Button
                fullWidth
                variant="contained"
                sx={{ mt: 2 }}
                href={`tel:${callNumber}`}
              >
                {callNumber}
              </Button>

            </CardContent>
          </Card>

        </Grid>

        {/* WHATSAPP */}

        <Grid className="col-sm-3 mb-2">

          <Card
            sx={{
              borderRadius: 4,
              transition: "0.3s",
              "&:hover": { transform: "translateY(-6px)" }
            }}
          >
            <CardContent>

              <Box
                sx={{
                  width: 56,
                  height: 56,
                  borderRadius: "50%",
                  bgcolor: "#2e7d32",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 2
                }}
              >
                <WhatsApp />
              </Box>

              <Typography fontWeight={700} fontSize={18}>
                WhatsApp Chat
              </Typography>

              <Typography color="text.secondary">
                Quick help on WhatsApp
              </Typography>

              <Button
                fullWidth
                variant="contained"
                sx={{ mt: 2, bgcolor: "#25D366" }}
                href={`https://wa.me/${whatsappNumber}`}
                target="_blank"
              >
                Start Chat
              </Button>

            </CardContent>
          </Card>

        </Grid>

        {/* EMAIL */}

        <Grid className="col-sm-3 mb-2">

          <Card
            sx={{
              borderRadius: 4,
              transition: "0.3s",
              "&:hover": { transform: "translateY(-6px)" }
            }}
          >
            <CardContent>

              <Box
                sx={{
                  width: 56,
                  height: 56,
                  borderRadius: "50%",
                  bgcolor: "#6a1b9a",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 2
                }}
              >
                <Email />
              </Box>

              <Typography fontWeight={700} fontSize={18}>
                Email Support
              </Typography>

              <Typography color="text.secondary">
                Response within 24 hours
              </Typography>

              <Button
                fullWidth
                variant="outlined"
                sx={{ mt: 2 }}
                href={`mailto:${email}`}
              >
                Send Email
              </Button>

            </CardContent>
          </Card>

        </Grid>

        {/* WEBSITE */}

        <Grid className="col-sm-3 mb-2">

          <Card
            sx={{
              borderRadius: 4,
              transition: "0.3s",
              "&:hover": { transform: "translateY(-6px)" }
            }}
          >
            <CardContent>

              <Box
                sx={{
                  width: 56,
                  height: 56,
                  borderRadius: "50%",
                  bgcolor: "#ff6f00",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 2
                }}
              >
                <Language />
              </Box>

              <Typography fontWeight={700} fontSize={18}>
                Visit Website
              </Typography>

              <Typography color="text.secondary">
                Explore our services
              </Typography>

              <Button
                fullWidth
                variant="contained"
                sx={{ mt: 2, bgcolor: "#ff6f00" }}
                href={website}
                target="_blank"
              >
                Open Website
              </Button>

            </CardContent>
          </Card>

        </Grid>

      </Grid>

    </Box>
  );
}

export default Help;